import { jsx as o } from "@emotion/react/jsx-runtime";
import { DrawerContentComponent as d } from "./DrawerContentComponent.js";
import { DynamicFiltersProvider as x } from "./DynamicFiltersContext.js";
const j = ({
  schema: r,
  filters: t,
  onApply: e,
  isFilterOpen: i,
  setIsFilterOpen: n,
  resetText: m,
  applyText: p,
  buttonText: f,
  title: l,
  getVisibleSchema: s,
  triggerElement: a,
  dataTrackId: c,
  disabled: D = !1
}) => /* @__PURE__ */ o(x, { filters: t, onApply: e, schema: r, isFilterOpen: i, setIsFilterOpen: n, children: /* @__PURE__ */ o(d, { schema: r, getVisibleSchema: s, resetText: m, applyText: p, buttonText: f, title: l, triggerElement: a, disabled: D, dataTrackId: c }) });
export {
  j as DynamicFilters
};
